import React, { useState, useEffect } from "react";
import { LineBoxContainer } from "../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../Button/CalendarLineBtn";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import DropDown from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import CalendarModal from "../../../Modal/CalendarModal";
import { CalendarLine } from "../ChatInfo/ChatSearch/RecentChat";
import { PartyInfoFilterContainer } from "../PartyInfo/PartyInfoFilter";
import UplusDataUploadModal from "./UplusDataUploadModal";
import UplusCodeDownloadModal from "./UplusCodeDownloadModal";
import { useRecoilState } from "recoil";
import { uplusInfoFilterState } from "../../../../pages/Party/UplusMatchingInfo";
import UplusCombineWaitListDownloadModal from "./UplusCombineWaitListDownloadModal";
import UplusCombineSuccessDownloadModal from "./UplusCombineSuccessDownloadModal";

interface UplusMatchingInfoFilterProps {
  pageResetEvent: () => void;
  fetchData: () => void;
}

const searchFilterTypeOption = [
  { value: "uid", label: "UID" },
  { value: "partyid", label: "PID" },
  { value: "name", label: "등록 이름" },
  { value: "phone", label: "등록 전화번호" },
  { value: "code", label: "결합 코드" },
  { value: "admin", label: "관리자 이름" },
];

const matchStatusOption = [
  { value: "1", label: "파티 대기" },
  { value: "2", label: "결합 대기" },
  { value: "3", label: "결합 완료" },
];

const dateOption = [
  { value: "1", label: "최초 등록일" },
  { value: "2", label: "최종 수정일" },
];

export default function UplusMatchingInfoFilter({
  fetchData,
  pageResetEvent,
}: UplusMatchingInfoFilterProps) {
  const [filter, setFilter] = useRecoilState(uplusInfoFilterState);
  const [filterType, setFilterType] = useState({
    value: filter?.searchType !== "" ? filter?.searchType : "",
    label:
      filter?.searchType !== ""
        ? searchFilterTypeOption?.find((f) => f.value === filter?.searchType)
            ?.label
        : "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>(
    filter?.searchValue !== "" ? filter?.searchValue : ""
  );
  const [startDate, setStartDate] = useState(
    filter?.startdate !== "" ? filter?.startdate : "날짜 선택"
  );
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState(
    filter?.enddate !== "" ? filter?.enddate : "날짜 선택"
  );
  const [endDateClick, setEndDateClick] = useState(false);
  const [modal, setModal] = useState({
    upload: false, // 데이터 업로드
    codeSendDowload: false, // 코드 발송 대상자 다운로드
    combineWaitDownload: false, // 결합 대기자 다운로드
    combineSuccessDownload: false, // 결합 완료자 다운로드
  });
  const [status, setStatus] = useState({
    value: filter?.stateValue !== "" ? filter?.stateValue : "",
    label:
      filter?.stateValue !== ""
        ? matchStatusOption?.find((m) => m.value === filter?.stateValue)?.label
        : "파티 상태 선택",
  });
  const [dateType, setDateType] = useState({
    value: filter?.dateType !== "" ? filter?.dateType : "",
    label:
      filter?.dateType !== ""
        ? dateOption?.find((d) => d.value === filter?.dateType)?.label
        : "등록/수정일 선택",
  });

  useEffect(() => {
    if (searchValue && searchValue?.length > 0) {
      setFilter((prev) => ({
        ...prev,
        searchType: filterType?.value,
        searchValue: `${searchValue}`,
      }));
    }
  }, [searchValue, filterType]);

  return (
    <>
      <PartyInfoFilterContainer maxWidth={1200}>
        <div />

        <Flex gapSize={10}>
          <LineBtn
            btnText="데이터 업로드"
            btnHeight={38}
            icon={"upload"}
            btnClickEvent={() =>
              setModal((prev) => ({
                ...prev,
                upload: true,
              }))
            }
          />

          <LineBtn
            btnText="코드 발송 대상자 다운로드"
            btnHeight={38}
            icon={"download"}
            btnClickEvent={() =>
              setModal((prev) => ({
                ...prev,
                codeSendDowload: true,
              }))
            }
          />

          <LineBtn
            btnText="결합 대기자 다운로드"
            btnHeight={38}
            icon={"download"}
            btnClickEvent={() =>
              setModal((prev) => ({
                ...prev,
                combineWaitDownload: true,
              }))
            }
          />

          <LineBtn
            btnText="결합 완료자 다운로드"
            btnHeight={38}
            icon={"download"}
            btnClickEvent={() =>
              setModal((prev) => ({
                ...prev,
                combineSuccessDownload: true,
              }))
            }
          />
        </Flex>
      </PartyInfoFilterContainer>

      <PartyInfoFilterContainer>
        <Flex gapSize={10}>
          <DropDown
            boxWidth={160}
            optionList={searchFilterTypeOption}
            dropdownValue={filterType}
            setDropDownValue={setFilterType}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            defaultValue={
              filter?.searchValue !== "" ? filter?.searchValue : undefined
            }
            pageResetEvent={() => pageResetEvent()}
            isDisabled={filterType?.value === ""}
            inputType={
              filterType?.value === "uid" ||
              filterType?.value === "partyid" ||
              filterType?.value === "phone"
                ? "number"
                : "text"
            }
          />
        </Flex>

        <Flex gapSize={10}>
          <FilterIcon />
          {/* 파티 상태 선택 */}
          <DropDown
            boxWidth={160}
            dropdownValue={status}
            setDropDownValue={setStatus}
            optionList={matchStatusOption}
          />

          {/* 등록/수정일 선택 */}
          <DropDown
            boxWidth={160}
            dropdownValue={dateType}
            setDropDownValue={setDateType}
            optionList={dateOption}
          />

          {/* 신청일 날짜 선택 */}
          <>
            <LineBoxContainer>
              <CalendarLineBtn
                onClickEvent={() => setStartDateClick(true)}
                value={startDate}
                initValue={"날짜 선택"}
                minWidth={155}
                disabled={dateType?.value === ""}
              />

              {startDateClick && (
                <CalendarModal
                  closeEvent={() => setStartDateClick(false)}
                  changeEvent={(date: string) => setStartDate(date)}
                  isFutureDisable={true}
                />
              )}
            </LineBoxContainer>

            <CalendarLine />

            <LineBoxContainer>
              <CalendarLineBtn
                onClickEvent={() => setEndDateClick(true)}
                value={endDate}
                initValue={"날짜 선택"}
                minWidth={155}
                disabled={startDate?.includes("선택")}
              />

              {endDateClick && (
                <CalendarModal
                  closeEvent={() => setEndDateClick(false)}
                  changeEvent={(date: string) => setEndDate(date)}
                  dateValue={startDate}
                  isAfterStartDate={true}
                />
              )}
            </LineBoxContainer>
          </>

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={
              status?.value === "" &&
              (startDate?.includes("선택") || endDate?.includes("선택"))
            }
            btnClickEvent={() => {
              pageResetEvent();
              setFilter((prev) => ({
                ...prev,
                stateValue: status?.value,
                dateType: dateType?.value,
                startdate: startDate,
                enddate: endDate,
              }));
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={
              status?.value === "" &&
              dateType?.value === "" &&
              startDate?.includes("선택") &&
              endDate?.includes("선택")
            }
            btnClickEvent={() => {
              setStartDate("날짜 선택");
              setEndDate("날짜 선택");

              setStatus({
                value: "",
                label: "결합 상태 선택",
              });

              setDateType({
                value: "",
                label: "등록/수정일 선택",
              });

              setFilter((prev) => ({
                ...prev,
                stateValue: "",
                dateType: "",
                startdate: "",
                enddate: "",
              }));
            }}
          />
        </Flex>
      </PartyInfoFilterContainer>

      <div />

      {modal.upload && (
        <UplusDataUploadModal
          closeEvent={() =>
            setModal((prev) => ({
              ...prev,
              upload: false,
            }))
          }
          confirmEvent={() => {
            fetchData();
          }}
        />
      )}

      {modal.codeSendDowload && (
        <UplusCodeDownloadModal
          closeEvent={() =>
            setModal((prev) => ({
              ...prev,
              codeSendDowload: false,
            }))
          }
        />
      )}

      {modal.combineWaitDownload && (
        <UplusCombineWaitListDownloadModal
          closeEvent={() =>
            setModal((prev) => ({
              ...prev,
              combineWaitDownload: false,
            }))
          }
        />
      )}

      {modal.combineSuccessDownload && (
        <UplusCombineSuccessDownloadModal
          closeEvent={() =>
            setModal((prev) => ({
              ...prev,
              combineSuccessDownload: false,
            }))
          }
        />
      )}
    </>
  );
}
